export function normalizeSchemaDefinition(schema, $sce) {
	if(schema === null || schema === undefined) {
		return schema;
	}

	if(Array.isArray(schema)) {
		return schema.map(item => normalizeSchemaDefinition(item, $sce));
	}

	if(typeof schema !== "object") {
		return schema;
	}

	const normalizedSchema = { ...schema };

	if(typeof normalizedSchema.type === "string") {
		normalizedSchema.type = normalizedSchema.type.toLowerCase();
	}

	if(normalizedSchema.type === "boolean" && normalizedSchema.description === undefined) {
		normalizedSchema.description = "";
	}

	if($sce) {
		if(typeof normalizedSchema.title === "string") {
			normalizedSchema.title = $sce.trustAsHtml(normalizedSchema.title);
		}
		if(typeof normalizedSchema.description === "string") {
			normalizedSchema.description = $sce.trustAsHtml(normalizedSchema.description);
		}
	}

	if(normalizedSchema.properties) {
		normalizedSchema.properties = Object.fromEntries(
			Object.entries(normalizedSchema.properties).map(([key, value]) => [key, normalizeSchemaDefinition(value, $sce)])
		);
	}

	if(normalizedSchema.items) {
		normalizedSchema.items = normalizeSchemaDefinition(normalizedSchema.items, $sce);
	}

	if(normalizedSchema.additionalProperties && typeof normalizedSchema.additionalProperties === "object") {
		normalizedSchema.additionalProperties = normalizeSchemaDefinition(normalizedSchema.additionalProperties, $sce);
	}

	if(normalizedSchema.oneOf) {
		normalizedSchema.oneOf = normalizedSchema.oneOf.map(item => normalizeSchemaDefinition(item, $sce));
	}

	if(normalizedSchema.anyOf) {
		normalizedSchema.anyOf = normalizedSchema.anyOf.map(item => normalizeSchemaDefinition(item, $sce));
	}

	if(normalizedSchema.allOf) {
		normalizedSchema.allOf = normalizedSchema.allOf.map(item => normalizeSchemaDefinition(item, $sce));
	}

	return normalizedSchema;
}